import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Layout, theme, Button, message, Input, Modal } from "antd";
import { FileTextOutlined, PlusOutlined } from "@ant-design/icons";
import LoadingOverlay from "react-loading-overlay-ts";

import TopBar from "../../components/TopBar";
import SideBar from "../../components/SideBar";
import { FuneralInvoiceTable } from "../../components/Table";
import {
  AddFuneralInvoiceModal,
  EditFuneralInvoiceModal,
  FuneralQuoteModal,
  FuneralInvoiceModal
} from "../../components/ModalForm";

import { AuthContext } from "../../context/AuthContext";

import "../../styles/Groups.css";
import {
  getCompanyFuneralInvoicesApi,
  addFuneralInvoiceApi,
  editFuneralInvoiceApi,
  searchFuneralInvoicesApi,
} from "../../services/Funeral/FuneralInvoiceApis";

const { Content } = Layout;
const { Search } = Input;

const FuneralInvoicePage: React.FC = () => {
  const [invoices, setInvoices] = useState<any>([]);
  const [invoice, setInvoice] = useState<any>({});
  const [quoteData, setQuoteData] = useState<any>({});
  const [invoiceData, setInvoiceData] = useState<any>({});
  const [filtered, setFiltered] = useState<any>([]);
  const [searchValue, setSearchValue] = useState<string>(
    () => sessionStorage.getItem("funeralInvoicesSearch") || ""
  );
  const [show, setShow] = useState(false);
  const [update, setUpdate] = useState(false);
  const [isActive, setActive] = useState(true);
  const [confirmDelete, setConfirmDelete] = useState(false); // State for confirmation modal
  const [groupToDelete, setGroupToDelete] = useState<string>(""); // State for confirmation modal
  const [key, setKey] = useState<string>(""); // State for confirmation modal
  const [state, setState] = useState({
    add: false,
    update: false,
    quote: false,
    invoice: false,
  });

  const { currentGroup } = useContext(AuthContext);

  const navigate = useNavigate();

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const showModal = () => {
    setShow(!show);
    setState({
      add: true,
      update: false,
      quote: false,
      invoice: false,
    });
  };

  const showEditModal = (data: any) => {
    const formData = {
      id: data.id,
      Group: data.Group,
      Type: data.Type,
      Customer: {
        value: data.FuneralCustomer.id,
        label: `${data.FuneralCustomer.Name} ${data.FuneralCustomer.Surname}`,
      },
      FuneralInvoiceLineItem: data.FuneralInvoiceLineItem,
      GrossTotal: data.GrossTotal,
      NettTotal: data.NettTotal,
      VATTotal: data.VATTotal,
    };

    setInvoice(formData);
    setShow(!show);
    setState({
      add: false,
      update: true,
      quote: false,
      invoice: false,
    });
  };

  const showQuoteModal = (data: any) => {
    setShow(!show);
    setQuoteData({ ...data });

    setState({
      add: false,
      update: false,
      quote: true,
      invoice: false,
    });
  };

  const showInvoiceModal = (data: any) => {
    setShow(!show);
    setInvoiceData({ ...data });

    setState({
      add: false,
      update: false,
      quote: false,
      invoice: true,
    });
  };

  const handleManage = (id: string) => {
    navigate(`/funeral/${id}`);
  };

  const handleAdd = async (data: any) => {
    setActive(true);

    return await addFuneralInvoiceApi(data, currentGroup)
      .then((res) => {
        console.log(res.data);
        setInvoices([...invoices, res.data]);
        setActive(false);
        return res;
      })
      .catch((err) => {
        setActive(false);
        console.log(err);
      });
  };

  const handleUpdate = async (id: string, data: any) => {
    setActive(true);

    return await editFuneralInvoiceApi(id, data)
      .then((res) => {
        const updatedInvoices = invoices.map((invoice: any) => {
          if (id === invoice.id) {
            return { ...invoice, ...res.data };
          }
          return invoice;
        });
        setInvoices(updatedInvoices);
        setActive(false);
        return res;
      })
      .catch((err) => {
        setActive(false);
        console.log(err);
      });
  };

  const handleDelete = (id: string, key: string) => {
    setKey(key);
    setConfirmDelete(true);
    setGroupToDelete(id);
  };

  const onSearch = async (e: any) => {
    const value = e.target.value;
    setSearchValue(value);
    if (value) sessionStorage.setItem("funeralInvoicesSearch", value);
    else sessionStorage.removeItem("funeralInvoicesSearch");
    if (value !== "") {
      const result = await searchFuneralInvoicesApi(String(currentGroup), value);
      const invoiceIds = new Set(invoices.map((i: any) => i.id));
      setFiltered(result.data.filter((i: any) => invoiceIds.has(i.id)));
    } else {
      setFiltered([]);
    }
  };

  const onCancelDelete = () => {
    setConfirmDelete(false);
    setGroupToDelete("");
  };

  const onConfirmDelete = () => {
    // setConfirmDelete(false);
    // setActive(true);
    // removeGroupApi(groupToDelete)
    //   .then((res) => {
    //     getGroupApi(String(currentGroup))
    //       .then((res) => {
    //         getLinkedGroupsApi(res.data.GroupLinkID, res.data.GroupLevel)
    //           .then((res) => {
    //             setActive(false);
    //             setGroups(res.data);
    //           })
    //           .catch((err) => {
    //             setActive(false);
    //             console.log(err);
    //           });
    //       })
    //       .catch((err) => {
    //         setActive(false);
    //         console.log(err);
    //       });
    //   })
    //   .catch((err) => {
    //     setActive(false);
    //     message.error(err);
    //     console.log(err);
    //   });
  };

  useEffect(() => {
    getCompanyFuneralInvoicesApi(String(currentGroup))
      .then((res) => {
        setInvoices(res.data);
        setActive(false);
      })

      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <LoadingOverlay active={isActive} spinner>
      <Layout style={{ minHeight: "100vh" }}>
        <SideBar />
        <Layout className="site-layout">
          <TopBar />
          <Content>
            <div
              style={{
                padding: 24,
                minHeight: "100%",
                background: colorBgContainer,
              }}
            >
              <h2>
                <FileTextOutlined
                  style={{ paddingRight: "5px", color: "#f04f05" }}
                />
                Invoices
              </h2>
              <div className="interactions">
                <Button onClick={showModal} size="large">
                  <PlusOutlined style={{ paddingRight: "5px" }} />
                  Add Invoice
                </Button>
                <div>
                  <Search
                    placeholder="Search"
                    size="large"
                    value={searchValue}
                    onChange={(e) => onSearch(e)}
                    style={{ width: "100%", margin: "24px 0" }}
                  />
                </div>
                {state.add && (
                  <AddFuneralInvoiceModal
                    show={show}
                    showModal={showModal}
                    handleAdd={handleAdd}
                  />
                )}

                {state.update && (
                  <EditFuneralInvoiceModal
                    show={show}
                    invoice={invoice}
                    showModal={showModal}
                    handleUpdate={handleUpdate}
                  />
                )}

                {state.quote && (
                  <FuneralQuoteModal
                    show={show}
                    showQuoteModal={showQuoteModal}
                    quote={quoteData}
                  />
                )}

                {state.invoice && (
                  <FuneralInvoiceModal
                    show={show}
                    showInvoiceModal={showInvoiceModal}
                    invoice={invoiceData}
                  />
                )}
              </div>

              <FuneralInvoiceTable
                invoices={invoices}
                filtered={filtered}
                showEditModal={showEditModal}
                showQuoteModal={showQuoteModal}
                showInvoiceModal={showInvoiceModal}
                handleManage={handleManage}
                handleDelete={handleDelete}
              />
            </div>
          </Content>
        </Layout>
      </Layout>

      {/* Confirmation Modal */}
      {/* {key === "1" ? (
        <Modal
          title="Confirm Remove"
          open={confirmDelete}
          onOk={onConfirmDelete}
          onCancel={onCancelDelete}
        >
          Are you sure you want to move this Invoice inactive?
        </Modal>
      ) : (
        <Modal
          title="Confirm Revert"
          open={confirmDelete}
          onOk={onConfirmDelete}
          onCancel={onCancelDelete}
        >
          Are you sure you want to move this Invoice active?
        </Modal>
      )} */}
    </LoadingOverlay>
  );
};

export default FuneralInvoicePage;
